var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrubSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77734 11.3335V6.66684C9.77734 6.40958 10.0254 6.24929 10.2229 6.37892L13.7785 8.71225C13.9745 8.84088 13.9745 9.15948 13.7785 9.2881L10.2229 11.6214C10.0254 11.7511 9.77734 11.5908 9.77734 11.3335ZM15.1087 6.62797C15.0915 6.46219 14.9663 6.33351 14.8143 6.33351C14.6507 6.33351 14.5181 6.48275 14.5181 6.66684V11.3335L14.52 11.3724C14.5372 11.5382 14.6624 11.6668 14.8143 11.6668C14.978 11.6668 15.1106 11.5176 15.1106 11.3335V6.66684L15.1087 6.62797Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22266 11.3335V6.66684C6.22266 6.40958 5.97459 6.24929 5.77706 6.37892L2.22151 8.71225C2.02551 8.84088 2.02551 9.15948 2.22151 9.2881L5.77706 11.6214C5.97459 11.7511 6.22266 11.5908 6.22266 11.3335ZM0.89135 6.62797C0.908465 6.46219 1.0337 6.33351 1.18565 6.33351C1.34929 6.33351 1.48195 6.48275 1.48195 6.66684V11.3335L1.47996 11.3724C1.46284 11.5382 1.3376 11.6668 1.18565 11.6668C1.02201 11.6668 0.889357 11.5176 0.889357 11.3335V6.66684L0.89135 6.62797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrubSpeed);
export default __webpack_public_path__ + "static/media/scrubSpeed.229a5a663f3c3b414c8aba67df885368.svg";
export { ForwardRef as ReactComponent };